export const EVENT_FOREX_CURRENCY_PAIR_CHANGE = 'forexCurrencyPairs.change'
